export const setAuth = auth => ({
    type: 'SET_AUTH',
    auth
})

// User
export const setUser = user => ({
    type: 'SET_USER',
    user
})

export const setReady = ready => ({
    type: 'SET_READY',
    ready
})

export const setRoutes = routes => ({
    type: 'SET_ROUTES',
    routes
})

export const setCurrency = currency => ({
    type: 'SET_CURRENCY',
    currency
})

export const setMenus = menus => ({
    type: 'SET_MENUS',
    menus
})

export const setContacts = contacts => ({
    type: 'SET_CONTACTS',
    contacts
})

export const setSocials = socials => ({
    type: 'SET_SOCIALS',
    socials
})

export const setActiveMobileMenu = active => ({
    type: 'SET_ACTIVE_MOBILE_MENU',
    active
})


export const setMobile = status => ({
    type: 'SET_MOBILE',
    status
})

// Content

export const setHomeContent = homeContent => ({
    type: 'SET_HOME_CONTENT',
    homeContent
})

// Content

export const setContent = date => ({
    type: 'SET_CONTENT',
    date
})

// MRKT Filters

export const setFilters = filters => ({
    type: 'SET_FILTER',
    filters
})

// Back To Marketplace

export const setBackToMrkt = backToMrkt => ({
    type: 'SET_BACK_TO_MRKT',
    backToMrkt
})

// MRKT Pagination

export const setMrktPaginate = mrktPaginate => ({
    type: 'SET_MRKT_PAGINATE',
    mrktPaginate
})

// Header Content

export const setHeaderContent = headerContent => ({
    type: 'SET_HEADER_CONTENT',
    headerContent
})

// SimplePopup

export const setSimplePopup = simplePopup => ({
    type: 'SET_SIMPLE_POPUP',
    simplePopup
})

// Plans

export const setPlans = plans => ({
    type: 'SET_PLANS',
    plans
})


// PlansDetails

export const setPlansDetails = plansDetails => ({
    type: 'SET_PLANS_DETAILS',
    plansDetails
})

// CHECKOUT CART
export const setCheckoutTab = tab => ({
    type: 'SET_CHECKOUT_TAB',
    tab
})

export const setCheckoutCart = cart => ({
    type: 'SET_CHECKOUT_CART',
    cart
})

// CART
export const setCart = cart => ({
    type: 'SET_CART',
    cart
})
export const setCheckoutOrder = cart => ({
    type: 'SET_CHECKOUT_ORDER',
    cart
})
export const remCart = index => ({
    type: 'REM_CART',
    index
})
export const addCart = item => ({
    type: 'ADD_CART',
    item
})

export const choosePlan = plan => ({
    type: 'CHOOSE_PLAN',
    plan
})

// Language
export const setLang = lang => ({
    type: 'SET_LANG',
    lang
})
